import {Box, Occupancy} from "@variocube/app-api";
import * as React from "react";
import {useCallback, useState} from "react";
import {PickupView} from "./PickupView";
import {SuccessView} from "./SuccessView";
import {useLocalization} from "../i18n";

interface PickupFlowProps {
    onExit: () => void;
    occupancies: Occupancy[];
    assignedLocks: string[];
    boxes: Box[];
    preventReopen?: boolean;
}

export function PickupFlow({onExit, ...pickupProps}: PickupFlowProps) {
    const {t} = useLocalization();
    const [success, setSuccess] = useState(false);

    const handlePickupConfirm = useCallback(() => setSuccess(true), []);

    if (success) {
        return (
            <SuccessView
                title={t("PickupSuccessTitle")}
                message={t("PickupSuccessMessage")}
                onClose={onExit}
            />
        )
    }
    return (
        <PickupView
            onDone={handlePickupConfirm}
            {...pickupProps}
        />
    )
}
